<form class="minicart-item minicart_product" [formGroup]="updateCartForm" (ngSubmit)="onSubmit()">
  <div class="minicart-item__wrapper">
    <figure class="minicart-item__image">
      <img
        ngSrcset="100w, 200w"
        height="100"
        width="100"
        [ngSrc]="product.image ?? ''"
        [alt]="product.title"
        [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
        (error)="product.image = missingProductImageUrl"
      />
    </figure>
    <div class="minicart-item__data">
      <!-- TODO: GET PRODUCT INFO IN ALL LANGUAGES -->
      <h2 class="minicart-item__title">
        <a href [sfProductLink]="product.product" (click)="clickProductLink()">{{
          product.product | translateProductField: 'title'
        }}</a>
      </h2>
      @if (product.stock > 0) {
        <span class="minicart-item__stock" i18n="@@IN_STOCK"> Product in stock </span>
      }
      <div class="qty-select">
        <button
          type="button"
          data-internal-id="minicart-quantity-dec"
          class="spinner-down"
          [ngClass]="product.quantity === 1 ? 'disabled' : ''"
          (click)="decrementQuantity(product.quantity)"
        >
          <span class="sr-only" i18n="@@MINUS">Decrement product quantity</span>
          <i class="far fa-minus"></i>
        </button>

        <input
          readonly
          class="form-control qty"
          min="1"
          data-testid="quantitySelector"
          [value]="product.quantity"
          [max]="product.stock > maxProductValue ? maxProductValue : product.stock"
        />
        <button
          type="button"
          class="spinner-up"
          data-internal-id="minicart-quantity-inc"
          [ngClass]="product.quantity >= (maxProductValue || product.stock) || currentProductsTillCartFull <= 0 ? 'disabled' : ''"
          (click)="incrementQuantity()"
        >
          <span class="sr-only" i18n="@@MINUS">Increment product quantity</span>
          <i class="far fa-plus"></i>
        </button>
      </div>

      <div class="minicart-item__actions">
        <!-- <button name="save-for-later-btn" (click)="addProductToWhishlist()"
        class="btn btn-link btn-sm" i18n="@@minicart.whishlist">
        Whishlist
      </button> -->
        <button
          type="button"
          name="remove-btn"
          class="btn btn-link btn-remove"
          (click)="removeProductFromMinicart()"
          i18n="@@REMOVE_FROM_CART"
        >
          Remove
        </button>
        <div class="minicart-item__price prices" data-testid="productPrice">
          @if (shouldShowCrossedPrice()) {
            <span class="crossed-price">
              {{ oldProductPrice | currency: currency : 'symbol' : '1.2-2' }}
            </span>
          }
          <span class="final-price">{{ productPrice | currency: currency : 'symbol' : '1.2-2' }}</span>
        </div>
      </div>
    </div>
  </div>
</form>
